"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

var _Button = _interopRequireDefault(require("../Button/Button"));

require("./DialogBox.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DialogBox = function DialogBox(_ref) {
  var show = _ref.show,
      id = _ref.id,
      onCancel = _ref.onCancel,
      onAccept = _ref.onAccept,
      title = _ref.title,
      content = _ref.content,
      accept = _ref.accept,
      cancel = _ref.cancel,
      toggle = _ref.toggle;

  var handleAccept = function handleAccept(e) {
    if (onAccept) onAccept(e);
    toggle && toggle();
  };

  var handleCancel = function handleCancel(e) {
    if (onCancel) onCancel(e);
    toggle && toggle();
  };

  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
    id: id,
    className: "gcl-dialog-box",
    isOpen: show,
    centered: true
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalBody, {
    className: "gcl-dialog-box-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dialog-box-body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-title-dialog-box"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-content-dialog-box"
  }, content))), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalFooter, null, cancel && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "tertiary",
    onClick: handleCancel
  }, cancel), accept && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "tertiary",
    onClick: handleAccept
  }, accept)));
};

DialogBox.propTypes = {
  id: _propTypes["default"].string,
  onCancel: _propTypes["default"].func,
  onAccept: _propTypes["default"].func,
  title: _propTypes["default"].string,
  content: _propTypes["default"].string,
  accept: _propTypes["default"].string,
  cancel: _propTypes["default"].string,
  show: _propTypes["default"].bool,
  toggle: _propTypes["default"].func
};
var _default = DialogBox;
exports["default"] = _default;